<div class="container-fluid vh-100 bg-light d-flex justify-content-center align-items-center">
  <div class="text-center px-3" style="max-width: 500px; width: 100%;">
    <!-- Logo Section -->
    <div class="mb-4">
      <img
        [ngSrc]="imgSrc"
        alt="NAUTOPSY Logo"
        class="img-fluid mb-3"
        width="660"
        height="371"
        priority
      />
    </div>

    <!-- Title -->
    <h5 class="mb-4">A dokumentum megnyitásához adja meg jelszavát!</h5>

    <!-- Form Section -->
    <div>
      <!-- Password Field -->
      <div class="mb-3">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Jelszó</mat-label>
          <input
            matInput
            [type]="hidePassword() ? 'password' : 'text'"
            [formControl]="passwordControl"
            autocomplete="current-password"
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="hidePassword.set(!hidePassword())"
            [attr.aria-label]="'Jelszó ' + (hidePassword() ? 'megjelenítés' : 'elrejtés')"
            [attr.aria-pressed]="!hidePassword()"
          >
            <mat-icon>{{ hidePassword() ? 'visibility' : 'visibility_off' }}</mat-icon>
          </button>
          @if (passwordControl.hasError('required') && passwordControl.touched) {
            <mat-error class="text-danger">Jelszó megadása kötelező!</mat-error>
          }
        </mat-form-field>
      </div>

      <!-- Submit Button -->
      <div class="d-grid">
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="passwordControl.invalid || isLoading()"
          (click)="openPdf()"
        >
          @if (isLoading()) {
            <mat-spinner diameter="20" class="me-2" style="display: inline-block;"></mat-spinner>
          }
          {{ isLoading() ? 'Megnyitás...' : 'Megnyitás' }}
        </button>
      </div>
    </div>
  </div>
</div>
